import $ from 'jquery';
import debounce from 'debounce';
import breakpoints, { keys } from './breakpoints';

function test($el, offset = 100) {
  const $win = $(window);
  const winTop = $win.scrollTop();
  const winBot = winTop + $win.height();
  const elTop = $el.offset().top;
  const elBot = elTop + $el.outerHeight();

  return (elTop <= (winBot - offset)) && ((winTop + offset) <= elBot);
}

export default () => {
  const allElements = $('.checkIfInView');
  const invalidElements = allElements.filter(function() {
    const { inViewMin, inViewMax } = $(this).data();
    let decision = false

    if (keys.includes(inViewMin) && keys.includes(inViewMax)) {
      if (!breakpoints.min[inViewMin].matches || !breakpoints.max[inViewMax].matches) {
        decision = true;
      }
    }

    if (keys.includes(inViewMin) && !breakpoints.min[inViewMin].matches) {
      decision = true;
    }

    if (keys.includes(inViewMax) && !breakpoints.max[inViewMax].matches) {
      decision = true;
    }

    if (decision) {
      $(this).removeClass('checkIfInView').addClass('inView');
    }

    return decision;
  });

  let elements = allElements.not(invalidElements);

  if ( !elements.length ) return;

  const handler = debounce(function() {
    if (!elements.length) {
      $(window).off('scroll', handler);
      return;
    }

    elements.each((i, node) => {
      const $el = $(node);
      const { inViewOffset, inViewClass } = $el.data();

      if (test($el, inViewOffset)) {
        $el
          .removeClass('checkIfInView')
          .addClass('inView')
          .addClass(inViewClass);

        setTimeout(function() {
          $el.removeClass('inView');
        }, 1100);
      }
    });

    elements = elements.filter('.checkIfInView');
  }, 50);
  handler();
  $(window).on('scroll', handler);
}
